// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CWarsDebug_wrapper_2oAsS"};